(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ck-flash-sale"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ck-flash-sale')) {
    class CKFlashSale extends HTMLElement {
      connectedCallback() {
        this.deadline = Date.parse(this.dataset.end);
        this.eligibleVariants = new Set((this.dataset.eligibleVariants || '').split(',').filter(Boolean));
        this.refresh = () => this.tick();
        document.addEventListener('variant:update', this.refresh);
        this.tick();
        this.interval = window.setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() {
        window.clearInterval(this.interval);
        document.removeEventListener('variant:update', this.refresh);
      }
      tick() {
        const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
        let eligible = true;
        if (this.dataset.placement === 'product') {
          const scope = this.closest('.shopify-section');
          const input = scope?.querySelector('product-form-component input[name="id"]');
          const id = input?.value || this.dataset.selectedVariant;
          eligible = this.eligibleVariants.has(String(id));
        }
        const wasHidden = this.hidden;
        this.hidden = !Number.isFinite(remaining) || remaining <= 0 || !eligible;
        if (wasHidden !== this.hidden && this.dataset.placement === 'bar') window.dispatchEvent(new Event('resize'));
        if (remaining <= 0) { window.clearInterval(this.interval); return; }
        const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
        for (const [unit, value] of Object.entries(values)) {
          const element = this.querySelector(`[data-time="${unit}"]`);
          const text = String(value).padStart(2, '0');
          if (element && element.textContent !== text) element.textContent = text;
        }
      }
    }
    customElements.define('ck-flash-sale', CKFlashSale);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ck-valenza-dimensions"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:update', function(event) {
    const detail = event.detail;
    if (!detail || !detail.data || !detail.resource) return;
    document.querySelectorAll('[data-valenza-product]').forEach(function(root) {
      if (root.dataset.valenzaProduct !== String(detail.data.productId)) return;
      const index = Number(root.dataset.orientationIndex);
      if (index < 0) return;
      const orientation = (detail.resource.options || [])[index] || '';
      const isRight = /right|rhf/i.test(orientation);
      root.dataset.facing = isRight ? 'rhf' : 'lhf';
      const photo = root.querySelector('[data-valenza-photo]');
      if (photo) photo.setAttribute('transform', isRight ? 'translate(1000 0) scale(-1 1)' : '');
      const label = root.querySelector('[data-valenza-orientation]');
      if (label) label.textContent = orientation;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-selector"] && !Shopify.designMode) return;
  try {
    function updatePanelWidth(root) {
    const input = root.querySelector('input[name="quantity"]');
    const output = root.querySelector('[data-ck-panel-width-summary]');
    if (!input || !output) return;
    const count = Math.max(1, Number(input.value) || 1);
    const width = Number(root.dataset.panelWidth);
    output.textContent = output.dataset.text.replace('[count]', count).replace('[width]', width).replace('[total]', count * width);
  }
  function refreshPanelWidths() {
    document.querySelectorAll('[data-ck-panel-quantity]').forEach(updatePanelWidth);
  }
  ['input', 'change', 'click'].forEach(type => document.addEventListener(type, event => {
    const root = event.target.closest('[data-ck-panel-quantity]');
    if (root) requestAnimationFrame(() => updatePanelWidth(root));
  }));
  document.addEventListener('variant:update', () => requestAnimationFrame(refreshPanelWidths));
  document.addEventListener('shopify:section:load', refreshPanelWidths);
  refreshPanelWidths();
  } catch(e) { console.error(e); }
})();

})();
